(function () {
  const STOREFRONT_ROOT = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  const COPY = {
    en: {
      title: 'Quick Basket',
      eyebrow: 'Order counter · 購物小票',
      continueShopping: 'Continue shopping',
      reassurance: 'Secure checkout · Worldwide delivery support'
    },
    'zh-tw': {
      title: '快速購物籃',
      eyebrow: '訂單櫃台 · 購物小票',
      continueShopping: '繼續購物',
      reassurance: '安全結帳 · 全球配送支援'
    },
    ja: {
      title: 'クイックカート',
      eyebrow: 'ご注文カウンター',
      continueShopping: '買い物を続ける',
      reassurance: '安全な決済 · 世界各国への配送をサポート'
    },
    ko: {
      title: '빠른 장바구니',
      eyebrow: '주문 카운터',
      continueShopping: '쇼핑 계속하기',
      reassurance: '안전한 결제 · 전 세계 배송 지원'
    }
  };
  let observerTimer = null;

  function getCopy() {
    const locale = (document.documentElement.lang || 'en').toLowerCase();
    if (locale.indexOf('zh') === 0) return COPY['zh-tw'];
    if (locale.indexOf('ja') === 0) return COPY.ja;
    if (locale.indexOf('ko') === 0) return COPY.ko;
    return COPY.en;
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function enhanceDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    const copy = getCopy();

    const header = drawer.querySelector('.drawer__header');
    const heading = drawer.querySelector('.drawer__heading');
    if (header && heading) {
      if (heading.textContent.trim() !== copy.title) heading.textContent = copy.title;
      if (!header.querySelector('.mc-quick-basket-eyebrow')) {
        const eyebrow = document.createElement('p');
        eyebrow.className = 'mc-quick-basket-eyebrow';
        eyebrow.textContent = copy.eyebrow;
        header.insertBefore(eyebrow, heading);
      }

    }

    const ctas = drawer.querySelector('.cart__ctas');
    if (ctas && !drawer.querySelector('.mc-quick-basket-continue')) {
      const continueLink = document.createElement('a');
      continueLink.href = '#';
      continueLink.className = 'mc-quick-basket-continue';
      continueLink.textContent = copy.continueShopping;
      continueLink.addEventListener('click', function (event) {
        event.preventDefault();
        drawer.close();
      });
      ctas.insertAdjacentElement('afterend', continueLink);
    }

    const footer = drawer.querySelector('.drawer__footer');
    if (footer && !drawer.querySelector('.mc-quick-basket-reassurance')) {
      const reassurance = document.createElement('p');
      reassurance.className = 'mc-quick-basket-reassurance';
      reassurance.textContent = copy.reassurance;
      footer.appendChild(reassurance);
    }

  }

  function isHeaderCartTrigger(element) {
    return element && element.closest && element.closest('#cart-icon-bubble, a.header__icon--cart');
  }

  function getQuickAddVariantId(form) {
    const input = form.querySelector('[name="id"]');
    if (input && input.value) return input.value;

    const productLink = form.parentElement && form.parentElement.querySelector('a[href*="variant="]');
    if (!productLink) return '';

    try {
      return new URL(productLink.href, window.location.href).searchParams.get('variant') || '';
    } catch (error) {
      return '';
    }
  }

  async function submitQuickAdd(event) {
    const form = event.target && event.target.closest && event.target.closest('form.mc-quick-form');
    if (!form) return;

    const drawer = getDrawer();
    const variantId = getQuickAddVariantId(form);
    if (!drawer || typeof drawer.renderContents !== 'function' || !variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }

    const formData = new FormData(form);
    formData.set('id', variantId);
    formData.set('quantity', formData.get('quantity') || '1');

    if (typeof drawer.getSectionsToRender === 'function') {
      formData.set('sections', drawer.getSectionsToRender().map(function (section) { return section.id; }));
      formData.set('sections_url', window.location.pathname);
    }

    const action = (form.getAttribute('action') || STOREFRONT_ROOT + 'cart/add').replace(/\.js$/, '') + '.js';

    try {
      const response = await fetch(action, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Unable to add this item.');
      drawer.renderContents(result);
      window.setTimeout(enhanceDrawer, 40);
    } catch (error) {
      console.error('MolalaCook quick add:', error);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    }
  }

  document.addEventListener('submit', submitQuickAdd, true);

  document.addEventListener(
    'click',
    function (event) {
      const quickAddButton = event.target.closest && event.target.closest('form.mc-quick-form [type="submit"]');
      if (quickAddButton) {
        submitQuickAdd(event);
        return;
      }

      const cartTrigger = isHeaderCartTrigger(event.target);
      const drawer = getDrawer();
      if (!cartTrigger || !drawer) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      enhanceDrawer();
      drawer.open(cartTrigger);
    },
    true
  );

  function scheduleEnhancement() {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(enhanceDrawer, 30);
  }

  document.addEventListener('DOMContentLoaded', function () {
    enhanceDrawer();
    const drawer = getDrawer();
    if (!drawer) return;
    new MutationObserver(scheduleEnhancement).observe(drawer, { childList: true, subtree: true });
  });
})();
